export default "__VITE_ASSET__DAQB$ciD__"